import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExpressmin = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.713 6.923h-2.517V3.846H2.448c-.924 0-1.679.692-1.679 1.539v8.461h1.679c0 1.277 1.124 2.308 2.517 2.308 1.393 0 2.518-1.03 2.518-2.308h5.035c0 1.277 1.124 2.308 2.517 2.308 1.393 0 2.517-1.03 2.517-2.308h1.679V10l-2.518-3.077Zm-.42 1.154L17.94 10h-3.743V8.077h2.098Zm-12.167 5.77c0 .422.377.768.839.768.462 0 .84-.346.84-.769 0-.423-.378-.769-.84-.769-.462 0-.84.346-.84.77Zm2.702-1.54a2.595 2.595 0 0 0-1.863-.768c-.747 0-1.401.3-1.863.769h-.654V5.385h10.07v6.923h-5.69Zm7.368 1.54c0 .422.377.768.839.768.461 0 .84-.346.84-.769 0-.423-.379-.769-.84-.769-.462 0-.84.346-.84.77Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgExpressmin);
export { ForwardRef as ReactComponent };
